// Mock data for Frelon33 website development
export const mockData = {
  // Contact form submissions (for development)
  contactSubmissions: [],
  
  // Service areas in Gironde  
  serviceAreas: [
    'Bordeaux', 'Mérignac', 'Pessac', 'Talence', 'Villenave-d\'Ornon',
    'Bègles', 'Cenon', 'Floirac', 'Gradignan', 'Le Bouscat', 'Lormont',
    'Saint-Médard-en-Jalles', 'Bruges', 'Eysines', 'Blanquefort'
  ],

  // Types of pests handled
  pestTypes: [
    { value: 'frelon-asiatique', label: 'Frelon asiatique' },
    { value: 'frelon-europeen', label: 'Frelon européen' },
    { value: 'guepe', label: 'Guêpe' },
    { value: 'bourdon', label: 'Bourdon' },
    { value: 'autre', label: 'Autre nuisible' }
  ],

  // Company guarantees
  guarantees: [
    {
      icon: 'Clock',
      title: 'Intervention sous 48h',
      description: 'Réactivité garantie pour toutes vos urgences'
    },
    {
      icon: 'Shield',
      title: 'Agréé & Certifié',
      description: 'Entreprise agréée avec toutes les certifications'
    },
    {
      icon: 'MapPin',
      title: 'Toute la Gironde',
      description: 'Intervention sur tout le département'
    },
    {
      icon: 'Phone',
      title: '7j/7 - 24h/24',
      description: 'Service d\'urgence disponible en permanence'
    }
  ],

  // Intervention process steps
  interventionSteps: [
    {
      step: 1,
      title: 'Diagnostic gratuit',
      description: 'Évaluation de la situation et devis immédiat'
    },
    {
      step: 2,
      title: 'Intervention sécurisée',
      description: 'Destruction du nid avec équipement professionnel'
    },
    {
      step: 3,
      title: 'Nettoyage & prévention',
      description: 'Élimination des traces et conseils préventifs'
    }
  ],

  // Asian hornet educational content
  asianHornetInfo: {
    origin: "Le frelon asiatique (Vespa velutina) est arrivé en France en 2004, probablement dans des poteries chinoises. Il s'est rapidement propagé sur tout le territoire.",
    dangers: [
      'Menace pour la biodiversité (destruction des abeilles)',
      'Risque de piqûres multiples en cas d\'attaque',
      'Impact économique sur l\'apiculture',
      'Destruction de l\'écosystème local'
    ],
    identification: [
      'Taille : 2 à 3 cm pour les ouvrières',
      'Couleur : Corps noir avec pattes jaunes',
      'Abdomen : Bande jaune-orange',
      'Vol : Stationnaire devant les ruches'
    ],
    nestTypes: [
      'Nids primaires (printemps) : petits, spheriques',
      'Nids secondaires (été/automne) : grands, en hauteur',
      'Localisation : Arbres, toitures, abris de jardin'
    ]
  }
};

// Mock functions for development
export const mockFunctions = {
  submitContactForm: (formData) => {
    console.log('📧 MOCK - Formulaire envoyé vers frelon33000@gmail.com:', formData);
    mockData.contactSubmissions.push({
      ...formData,
      id: Date.now(),
      timestamp: new Date().toISOString(),
      status: 'pending'
    });
    return Promise.resolve({ success: true, message: 'Demande envoyée avec succès!' });
  },

  callPhone: () => {
    console.log('📞 MOCK - Appel vers le 06 76 58 30 38');
    return Promise.resolve();
  }
};